<template>
  <div class="columns">
    <div class="column is-narrow">
      <router-link to="/" class="button has-addons is-light my-link">
        <span class="icon is-small"><font-awesome-icon icon="fa-solid fa-arrow-up-9-1" /></span>
        <span class="can-be-splitted">Мои обращения</span>
      </router-link>
    </div>
    <div class="column is-narrow">
      <router-link to="/create" class="button has-addons is-light my-link">
        <span class="icon is-small"><font-awesome-icon icon="fa-solid fa-pen-to-square" /></span>
        <span class="can-be-splitted">Создать обращение</span>
      </router-link>
    </div>
    <div class="column is-narrow">
      <router-link to="/proposal" class="button has-addons is-light my-link">
        <span class="icon is-small"><font-awesome-icon icon="fa-solid fa-list-check" /></span>
        <span class="can-be-splitted">Заявки на согласовании <span class="my-badge" v-if="new_requests.length">{{ new_requests.length }}</span></span>
      </router-link>
    </div>
    <div class="column is-narrow">
      <button v-on:click="sendReport()" class="button has-addons is-light my-link" :class="loadingReport ? 'is-loading' : ''" :disabled="disabled && !loadingReport">
        <span class="icon is-small"><font-awesome-icon icon="fa-solid fa-at" /></span>
        <span class="can-be-splitted">Получить отчёт</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Menu",
  data() {
    return {
      disabled: !this.$config.REPORT_IS_WORKING,
      loadingReport: false
    }
  },
  computed: {
    new_requests() {
      return this.requests.filter(el => el['Статус'] === '0. Зарегистрировано')
    },
    requests() {
      return this.$store.getters.REQUESTS
    }
  },
  methods: {
    sendReport: async function () {
      this.loadingReport = true
      let url = `${this.$config.SSL}://${this.$config.ONEADDRESS}/${this.$config.DB}/${this.$config.API_VERSION}/GetReport`
      let properies = {
        method: 'POST',
        withCredentials: true,
        headers: {
          "Authorization": "Bearer " + this.$store.getters.TOKEN
        }
      }

      await fetch(url, properies)
          .then(response => response.text())
          .then(result => {
            this.loadingReport = false
            alert('Отчёт отправлен на адрес электронной почты')
            console.log(result)
          }).catch(err => {
            this.loadingReport = false
            alert('Отчёт отправлен на адрес электронной почты')
            console.log(err)
          })
    }
  }
}
</script>

<style scoped lang="scss">
.my-badge {
  font-size: 70%;
  padding: 0 5px;
  background-color: rgb(212, 59, 89);
  color: white;
  border-radius: 100px;
}

.my-link {
  width: 100%;
  border: 1px dashed rgba(0,0,0,0.1) !important;
}
.button {
  justify-content: left !important;
}
.can-be-splitted {
  word-wrap: break-word !important;
}

.is-active {
  text-decoration: underline 1px dashed rgb(45, 140, 0);
  border: 0px dashed red !important;
  //background-color: rgb(45, 140, 0) !important;
  //color: #ffffff !important;
  //font-weight: bold !important;
  .icon {
    color: rgb(45, 140, 0) !important;
    animation: shake 10s ease-in-out 0s infinite alternate-reverse backwards;
  }
}


@keyframes shake {
  0%,
  100% {
    transform: rotate(0deg);
    transform-origin: 50% 50%;
  }

  10% {
    transform: rotate(8deg);
  }

  20%,
  40%,
  60% {
    transform: rotate(-10deg);
  }

  30%,
  50%,
  70% {
    transform: rotate(10deg);
  }

  80% {
    transform: rotate(-8deg);
  }

  90% {
    transform: rotate(8deg);
  }
}
</style>
